import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root') as HTMLElement;
const appElement = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Check if we're in a prerendered environment (react-snap)
if (rootElement.hasChildNodes()) {
  // For prerendered content, use hydrateRoot in React 18+
  const root = ReactDOM.hydrateRoot(rootElement, appElement);
} else {
  // For normal rendering
  const root = ReactDOM.createRoot(rootElement);
  root.render(appElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
